import InvoiceType from "@/models/Invoices/InvoiceType";

export default (value: InvoiceType) => {
    switch (value) {
        case InvoiceType.Temp:
            return "Temp";
        case InvoiceType.Perm:
            return "Perm";

        default:
            return "Unknown";
    }
} 